module.exports = __webpack_public_path__ + "img/ErrorPage.832b3538.jpg";